import {createSelector} from "../../../__snowpack__/pkg/@reduxjs/toolkit.js";
function selectFiltersBase(state) {
  return state.filters;
}
export const selectWhiteLabelFilters = createSelector([selectFiltersBase], (filters) => filters.whiteLabel);
export const selectAccountFilters = createSelector([selectFiltersBase], (filters) => filters.account);
